import { AuthenticationAssuranceLevel, ScopeType, AuditPolicy, IdempotencyPolicy, ConcurrencyPolicy, PrivacyClassification, ActorType, } from './operation.js';
import * as OID from './operation-ids.js';
export const PLATFORM_OPERATIONS = {
    // ─── Experience / View operations ───
    [OID.DASHBOARD_VIEW]: {
        id: OID.DASHBOARD_VIEW,
        name: 'View Dashboard',
        labelKey: 'operations.dashboard.view.label',
        descriptionKey: 'operations.dashboard.view.description',
        permission: 'organization:dashboard:read',
        permissionId: 'organization:dashboard:read',
        module: 'DASHBOARD',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'dashboard.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.HOLDINGS_VIEW]: {
        id: OID.HOLDINGS_VIEW,
        name: 'View Holdings',
        labelKey: 'operations.holdings.view.label',
        descriptionKey: 'operations.holdings.view.description',
        permission: 'organization:holdings:read',
        permissionId: 'organization:holdings:read',
        module: 'HOLDINGS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'holdings.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.REPORTS_VIEW]: {
        id: OID.REPORTS_VIEW,
        name: 'View Reports',
        labelKey: 'operations.reports.view.label',
        descriptionKey: 'operations.reports.view.description',
        permission: 'organization:reports:read',
        permissionId: 'organization:reports:read',
        module: 'REPORTING',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reports.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.REPORT_DETAIL_READ]: {
        id: OID.REPORT_DETAIL_READ,
        name: 'Read Report Detail',
        labelKey: 'operations.reports.detail.read.label',
        descriptionKey: 'operations.reports.detail.read.description',
        permission: 'organization:reports:read',
        permissionId: 'organization:reports:read',
        module: 'REPORTING',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
            ScopeType.PORTFOLIO,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
            clientAccountId: [{ source: 'query', field: 'clientAccountId' }],
            portfolioId: [{ source: 'query', field: 'portfolioAccountId' }],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'reports.detail.read',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_VIEW]: {
        id: OID.RECONCILIATION_VIEW,
        name: 'View Reconciliation',
        labelKey: 'operations.reconciliation.view.label',
        descriptionKey: 'operations.reconciliation.view.description',
        permission: 'organization:reconciliation:read',
        permissionId: 'organization:reconciliation:read',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.CORPORATE_ACTIONS_VIEW]: {
        id: OID.CORPORATE_ACTIONS_VIEW,
        name: 'View Corporate Actions',
        labelKey: 'operations.corporateActions.view.label',
        descriptionKey: 'operations.corporateActions.view.description',
        permission: 'organization:corporate-actions:read',
        permissionId: 'organization:corporate-actions:read',
        module: 'CORPORATE_ACTIONS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'corporateActions.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.SETTINGS_VIEW]: {
        id: OID.SETTINGS_VIEW,
        name: 'View Settings',
        labelKey: 'operations.settings.view.label',
        descriptionKey: 'operations.settings.view.description',
        permission: 'settings:view',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.view',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.SETTINGS_PROFILE]: {
        id: OID.SETTINGS_PROFILE,
        name: 'View Profile Settings',
        labelKey: 'operations.settings.profile.label',
        descriptionKey: 'operations.settings.profile.description',
        permission: 'settings:profile',
        permissionId: 'settings:profile',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.profile',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.SETTINGS_PREFERENCES]: {
        id: OID.SETTINGS_PREFERENCES,
        name: 'View Preferences',
        labelKey: 'operations.settings.preferences.label',
        descriptionKey: 'operations.settings.preferences.description',
        permission: 'settings:preferences',
        permissionId: 'settings:preferences',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.preferences',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.SETTINGS_PROFILE_UPDATE]: {
        id: OID.SETTINGS_PROFILE_UPDATE,
        name: 'Update Profile Settings',
        labelKey: 'operations.settings.profile.update.label',
        descriptionKey: 'operations.settings.profile.update.description',
        permission: 'settings:profile:update',
        permissionId: 'settings:profile:update',
        permissionByActorType: { [ActorType.CLIENT]: 'client:profile:limited-update' },
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        // Profile mutation has no persisted version column and no conditional-update
        // path; declaring OPTIMISTIC_VERSION would promise a guarantee persistence
        // does not implement. Use NONE until a real versioned-settings contract lands.
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.profile.update',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.SETTINGS_PREFERENCES_UPDATE]: {
        id: OID.SETTINGS_PREFERENCES_UPDATE,
        name: 'Update Preferences',
        labelKey: 'operations.settings.preferences.update.label',
        descriptionKey: 'operations.settings.preferences.update.description',
        permission: 'settings:preferences:update',
        permissionId: 'settings:preferences:update',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        // Preferences mutation has no persisted version column and no conditional-update
        // path; declaring OPTIMISTIC_VERSION would promise a guarantee persistence
        // does not implement. Use NONE until a real versioned-settings contract lands.
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.preferences.update',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.SETTINGS_MFA]: {
        id: OID.SETTINGS_MFA,
        name: 'View MFA Settings',
        labelKey: 'operations.settings.mfa.label',
        descriptionKey: 'operations.settings.mfa.description',
        permission: 'settings:mfa',
        permissionId: 'settings:mfa',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.mfa',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.SETTINGS_SECURITY]: {
        id: OID.SETTINGS_SECURITY,
        name: 'View Security Overview',
        labelKey: 'operations.settings.security.label',
        descriptionKey: 'operations.settings.security.description',
        permission: 'settings:security',
        permissionId: 'settings:security',
        module: 'SETTINGS',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'settings.security',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_HUB]: {
        id: OID.ADMIN_HUB,
        name: 'View Admin Hub',
        labelKey: 'operations.admin.hub.label',
        descriptionKey: 'operations.admin.hub.description',
        permission: 'admin:hub',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.hub',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_HUB_PLATFORM]: {
        id: OID.ADMIN_HUB_PLATFORM,
        name: 'View Platform Admin Hub',
        labelKey: 'operations.admin.hub.platform.label',
        descriptionKey: 'operations.admin.hub.platform.description',
        permission: 'admin:hub',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.hub.platform',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_HUB_ORGANIZATION]: {
        id: OID.ADMIN_HUB_ORGANIZATION,
        name: 'View Organization Admin Hub',
        labelKey: 'operations.admin.hub.organization.label',
        descriptionKey: 'operations.admin.hub.organization.description',
        permission: 'admin:hub',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.hub.organization',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.DATA_HUB]: {
        id: OID.DATA_HUB,
        name: 'View Data Hub',
        labelKey: 'operations.data.hub.label',
        descriptionKey: 'operations.data.hub.description',
        permission: 'data:hub',
        module: 'DATA',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'data.hub',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.ADMIN_USERS_VIEW]: {
        id: OID.ADMIN_USERS_VIEW,
        name: 'View Users',
        labelKey: 'operations.admin.users.view.label',
        descriptionKey: 'operations.admin.users.view.description',
        permission: 'admin.users.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.users.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_USERS_DETAIL]: {
        id: OID.ADMIN_USERS_DETAIL,
        name: 'View User Detail',
        labelKey: 'operations.admin.users.detail.label',
        descriptionKey: 'operations.admin.users.detail.description',
        permission: 'admin.users.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.users.detail',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ROLES_VIEW]: {
        id: OID.ADMIN_ROLES_VIEW,
        name: 'View Roles',
        labelKey: 'operations.admin.roles.view.label',
        descriptionKey: 'operations.admin.roles.view.description',
        permission: 'admin.roles.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.roles.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ROLES_DETAIL]: {
        id: OID.ADMIN_ROLES_DETAIL,
        name: 'View Role Detail',
        labelKey: 'operations.admin.roles.detail.label',
        descriptionKey: 'operations.admin.roles.detail.description',
        permission: 'admin.roles.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.roles.detail',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ORGANIZATION_VIEW]: {
        id: OID.ADMIN_ORGANIZATION_VIEW,
        name: 'View Organization',
        labelKey: 'operations.admin.organization.view.label',
        descriptionKey: 'operations.admin.organization.view.description',
        permission: 'admin.organization.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.organization.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_AUDIT_VIEW]: {
        id: OID.ADMIN_AUDIT_VIEW,
        name: 'View Audit Log',
        labelKey: 'operations.admin.audit.view.label',
        descriptionKey: 'operations.admin.audit.view.description',
        permission: 'admin.audit.view',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.audit.view',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Auth operations ───
    [OID.AUTH_LOGIN]: {
        id: OID.AUTH_LOGIN,
        name: 'User Login',
        labelKey: 'operations.auth.login.label',
        descriptionKey: 'operations.auth.login.description',
        permission: 'auth:login',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.login',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_LOGOUT]: {
        id: OID.AUTH_LOGOUT,
        name: 'User Logout',
        labelKey: 'operations.auth.logout.label',
        descriptionKey: 'operations.auth.logout.description',
        permission: 'auth:logout',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.logout',
        allowedActorTypes: [
            ActorType.USER,
            ActorType.CLIENT,
            ActorType.SUPPORT_DELEGATE,
            ActorType.SYSTEM,
            ActorType.SERVICE_ACCOUNT,
        ],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_REFRESH]: {
        id: OID.AUTH_REFRESH,
        name: 'Refresh Session',
        labelKey: 'operations.auth.refresh.label',
        descriptionKey: 'operations.auth.refresh.description',
        permission: 'auth:refresh',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.NONE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.refresh',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_CHALLENGE_TOTP]: {
        id: OID.AUTH_CHALLENGE_TOTP,
        name: 'Verify TOTP Challenge',
        labelKey: 'operations.auth.challenge.totp.label',
        descriptionKey: 'operations.auth.challenge.totp.description',
        permission: 'auth:challenge',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.challenge.totp',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_CHALLENGE_RECOVERY]: {
        id: OID.AUTH_CHALLENGE_RECOVERY,
        name: 'Verify Recovery Code Challenge',
        labelKey: 'operations.auth.challenge.recovery.label',
        descriptionKey: 'operations.auth.challenge.recovery.description',
        permission: 'auth:challenge',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.challenge.recovery',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_SELECT_CONTEXT]: {
        id: OID.AUTH_SELECT_CONTEXT,
        name: 'Select Authorization Context',
        labelKey: 'operations.auth.selectContext.label',
        descriptionKey: 'operations.auth.selectContext.description',
        permission: 'auth:context',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.selectContext',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_PASSWORD_FORGOT]: {
        id: OID.AUTH_PASSWORD_FORGOT,
        name: 'Request Password Reset',
        labelKey: 'operations.auth.password.forgot.label',
        descriptionKey: 'operations.auth.password.forgot.description',
        permission: 'auth:password:forgot',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.password.forgot',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_PASSWORD_RESET]: {
        id: OID.AUTH_PASSWORD_RESET,
        name: 'Reset Password',
        labelKey: 'operations.auth.password.reset.label',
        descriptionKey: 'operations.auth.password.reset.description',
        permission: 'auth:password:reset',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'auth.password.reset',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_INVITATION_ACCEPT]: {
        id: OID.AUTH_INVITATION_ACCEPT,
        name: 'Accept Organization Invitation',
        labelKey: 'operations.auth.invitation.accept.label',
        descriptionKey: 'operations.auth.invitation.accept.description',
        permission: 'auth:invitation:accept',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM],
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'auth.invitation.accept',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_PASSWORD_CHANGE]: {
        id: OID.AUTH_PASSWORD_CHANGE,
        name: 'Change Password',
        labelKey: 'operations.auth.password.change.label',
        descriptionKey: 'operations.auth.password.change.description',
        permission: 'settings:password:change',
        module: 'AUTH',
        requiresEntitledModule: false,
        // P1-012: Endpoint enforces recent-auth (5-min window) plus current-password verification.
        // If MFA is enrolled, TOTP verification is required. No AAL2 enforcement; AAL1 allows form access.
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'auth.password.change',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_SESSION_MANAGE]: {
        id: OID.AUTH_SESSION_MANAGE,
        name: 'Manage Sessions',
        labelKey: 'operations.auth.sessions.manage.label',
        descriptionKey: 'operations.auth.sessions.manage.description',
        permission: 'settings:sessions',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.sessions.manage',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.AUTH_SESSION_REVOKE]: {
        id: OID.AUTH_SESSION_REVOKE,
        name: 'Revoke Session',
        labelKey: 'operations.auth.sessions.revoke.label',
        descriptionKey: 'operations.auth.sessions.revoke.description',
        permission: 'settings:sessions',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.sessions.revoke',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_ENROLL_MFA]: {
        id: OID.AUTH_ENROLL_MFA,
        name: 'Enroll MFA',
        labelKey: 'operations.auth.mfa.enroll.label',
        descriptionKey: 'operations.auth.mfa.enroll.description',
        permission: 'settings:mfa',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.mfa.enroll',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_VERIFY_MFA]: {
        id: OID.AUTH_VERIFY_MFA,
        name: 'Verify MFA Enrollment',
        labelKey: 'operations.auth.mfa.verify.label',
        descriptionKey: 'operations.auth.mfa.verify.description',
        permission: 'settings:mfa',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.mfa.verify',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_DISABLE_MFA]: {
        id: OID.AUTH_DISABLE_MFA,
        name: 'Disable MFA',
        labelKey: 'operations.auth.mfa.disable.label',
        descriptionKey: 'operations.auth.mfa.disable.description',
        permission: 'settings:mfa',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.mfa.disable',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_REGENERATE_BACKUP_CODES]: {
        id: OID.AUTH_REGENERATE_BACKUP_CODES,
        name: 'Regenerate MFA Backup Codes',
        labelKey: 'operations.auth.mfa.backupCodes.regenerate.label',
        descriptionKey: 'operations.auth.mfa.backupCodes.regenerate.description',
        permission: 'settings:mfa',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.mfa.backupCodes.regenerate',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_READ_PROFILE]: {
        id: OID.AUTH_READ_PROFILE,
        name: 'Read My Profile',
        labelKey: 'operations.auth.readProfile.label',
        descriptionKey: 'operations.auth.readProfile.description',
        permission: 'auth:profile:read',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM', 'ORGANIZATION', 'BRANCH', 'CLIENT'],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.readProfile',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        permissionByActorType: { [ActorType.CLIENT]: 'client:profile:read' },
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.AUTH_SWITCH_CONTEXT]: {
        id: OID.AUTH_SWITCH_CONTEXT,
        name: 'Switch Active Context',
        labelKey: 'operations.auth.switchContext.label',
        descriptionKey: 'operations.auth.switchContext.description',
        permission: 'auth:context:switch',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: 'auth.switchContext',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_ENTER_DELEGATION]: {
        id: OID.AUTH_ENTER_DELEGATION,
        name: 'Enter Support Delegation',
        labelKey: 'operations.auth.delegation.enter.label',
        descriptionKey: 'operations.auth.delegation.enter.description',
        permission: 'platform:support-delegations:enter',
        module: 'AUTH',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {},
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.OPTIONAL,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'auth.delegation.enter',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.AUTH_EXIT_DELEGATION]: {
        id: OID.AUTH_EXIT_DELEGATION,
        name: 'Exit Support Delegation',
        labelKey: 'operations.auth.delegation.exit.label',
        descriptionKey: 'operations.auth.delegation.exit.description',
        permission: 'platform:support-delegations:exit',
        permissionId: 'platform:support-delegations:exit',
        module: 'AUTH',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'auth.delegation.exit',
        allowedActorTypes: [ActorType.SUPPORT_DELEGATE],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    // ─── Health operations ───
    [OID.PLATFORM_HEALTH_CHECK]: {
        id: OID.PLATFORM_HEALTH_CHECK,
        name: 'Health Check',
        labelKey: 'operations.platform.health.check.label',
        descriptionKey: 'operations.platform.health.check.description',
        permission: 'platform:health:read',
        permissionId: 'platform:health:read',
        module: 'PLATFORM',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.NONE,
        privacyClassification: PrivacyClassification.PUBLIC,
        telemetryId: 'platform.health.check',
        allowedActorTypes: [ActorType.SYSTEM, ActorType.SERVICE_ACCOUNT, ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_HEALTH_READINESS]: {
        id: OID.PLATFORM_HEALTH_READINESS,
        name: 'Readiness Check',
        labelKey: 'operations.platform.health.readiness.label',
        descriptionKey: 'operations.platform.health.readiness.description',
        permission: 'platform:health:read',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.NONE,
        privacyClassification: PrivacyClassification.PUBLIC,
        telemetryId: 'platform.health.readiness',
        allowedActorTypes: [ActorType.SYSTEM, ActorType.SERVICE_ACCOUNT],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_HEALTH_LIVENESS]: {
        id: OID.PLATFORM_HEALTH_LIVENESS,
        name: 'Liveness Check',
        labelKey: 'operations.platform.health.liveness.label',
        descriptionKey: 'operations.platform.health.liveness.description',
        permission: 'platform:health:read',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.NONE,
        privacyClassification: PrivacyClassification.PUBLIC,
        telemetryId: 'platform.health.liveness',
        allowedActorTypes: [ActorType.SYSTEM, ActorType.SERVICE_ACCOUNT],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Branch / Module / License operations ───
    [OID.PLATFORM_MODULE_ENABLE]: {
        id: OID.PLATFORM_MODULE_ENABLE,
        name: 'Enable Module',
        labelKey: 'operations.platform.module.enable.label',
        descriptionKey: 'operations.platform.module.enable.description',
        permission: 'platform:manage:modules',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.platform.module.enable.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.ADVISORY_LOCK,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.module.enable',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_MODULE_DISABLE]: {
        id: OID.PLATFORM_MODULE_DISABLE,
        name: 'Disable Module',
        labelKey: 'operations.platform.module.disable.label',
        descriptionKey: 'operations.platform.module.disable.description',
        permission: 'platform:manage:modules',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.platform.module.disable.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.module.disable',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_ENTITLEMENTS_LIST]: {
        id: OID.PLATFORM_ENTITLEMENTS_LIST,
        name: 'List Module Entitlements',
        labelKey: 'operations.platform.entitlements.list.label',
        descriptionKey: 'operations.platform.entitlements.list.description',
        permission: 'platform:view:modules',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.entitlements.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_LICENSE_CREATE]: {
        id: OID.PLATFORM_LICENSE_CREATE,
        name: 'Create Module License',
        labelKey: 'operations.platform.license.create.label',
        descriptionKey: 'operations.platform.license.create.description',
        permission: 'platform:manage:licenses',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.platform.license.create.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.ADVISORY_LOCK,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.license.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_LICENSE_LIST]: {
        id: OID.PLATFORM_LICENSE_LIST,
        name: 'List Module Licenses',
        labelKey: 'operations.platform.license.list.label',
        descriptionKey: 'operations.platform.license.list.description',
        permission: 'platform:view:licenses',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.license.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Import operations ───
    [OID.IMPORT_LIST]: {
        id: OID.IMPORT_LIST,
        name: 'List Import Jobs',
        labelKey: 'operations.import.list.label',
        descriptionKey: 'operations.import.list.description',
        permission: 'import:view',
        module: 'IMPORT',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'import.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.IMPORT_GET]: {
        id: OID.IMPORT_GET,
        name: 'Get Import Job',
        labelKey: 'operations.import.get.label',
        descriptionKey: 'operations.import.get.description',
        permission: 'import:view',
        module: 'IMPORT',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'import.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.IMPORT_UPLOAD]: {
        id: OID.IMPORT_UPLOAD,
        name: 'Upload Import File',
        labelKey: 'operations.import.upload.label',
        descriptionKey: 'operations.import.upload.description',
        permission: 'import:create',
        module: 'IMPORT',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'import.upload',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.IMPORT_COMMIT]: {
        id: OID.IMPORT_COMMIT,
        name: 'Commit Import Job',
        labelKey: 'operations.import.commit.label',
        descriptionKey: 'operations.import.commit.description',
        permission: 'import:commit',
        module: 'IMPORT',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'import.commit',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.IMPORT_VALIDATE]: {
        id: OID.IMPORT_VALIDATE,
        name: 'Validate Import Job',
        labelKey: 'operations.import.validate.label',
        descriptionKey: 'operations.import.validate.description',
        permission: 'import:validate',
        module: 'IMPORT',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'import.validate',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Reconciliation operations ───
    [OID.RECONCILIATION_LIST]: {
        id: OID.RECONCILIATION_LIST,
        name: 'List Reconciliation Runs',
        labelKey: 'operations.reconciliation.list.label',
        descriptionKey: 'operations.reconciliation.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_GET]: {
        id: OID.RECONCILIATION_GET,
        name: 'Get Reconciliation Run',
        labelKey: 'operations.reconciliation.get.label',
        descriptionKey: 'operations.reconciliation.get.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_CREATE]: {
        id: OID.RECONCILIATION_CREATE,
        name: 'Create Reconciliation Run',
        labelKey: 'operations.reconciliation.create.label',
        descriptionKey: 'operations.reconciliation.create.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_STATEMENT_CREATE]: {
        id: OID.RECONCILIATION_STATEMENT_CREATE,
        name: 'Create Reconciliation Statement',
        labelKey: 'operations.reconciliation.statement.create.label',
        descriptionKey: 'operations.reconciliation.statement.create.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.statement.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_STATEMENT_LIST]: {
        id: OID.RECONCILIATION_STATEMENT_LIST,
        name: 'List Reconciliation Statements',
        labelKey: 'operations.reconciliation.statement.list.label',
        descriptionKey: 'operations.reconciliation.statement.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.statement.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_STATEMENT_GET]: {
        id: OID.RECONCILIATION_STATEMENT_GET,
        name: 'Get Reconciliation Statement',
        labelKey: 'operations.reconciliation.statement.get.label',
        descriptionKey: 'operations.reconciliation.statement.get.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.statement.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_CREATE]: {
        id: OID.RECONCILIATION_RUN_CREATE,
        name: 'Create Reconciliation Run',
        labelKey: 'operations.reconciliation.run.create.label',
        descriptionKey: 'operations.reconciliation.run.create.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_LIST]: {
        id: OID.RECONCILIATION_RUN_LIST,
        name: 'List Reconciliation Runs',
        labelKey: 'operations.reconciliation.run.list.label',
        descriptionKey: 'operations.reconciliation.run.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_GET]: {
        id: OID.RECONCILIATION_RUN_GET,
        name: 'Get Reconciliation Run',
        labelKey: 'operations.reconciliation.run.get.label',
        descriptionKey: 'operations.reconciliation.run.get.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_BREAKS_LIST]: {
        id: OID.RECONCILIATION_RUN_BREAKS_LIST,
        name: 'List Reconciliation Run Breaks',
        labelKey: 'operations.reconciliation.run.breaks.list.label',
        descriptionKey: 'operations.reconciliation.run.breaks.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.breaks.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_MATCHES_LIST]: {
        id: OID.RECONCILIATION_RUN_MATCHES_LIST,
        name: 'List Reconciliation Run Matches',
        labelKey: 'operations.reconciliation.run.matches.list.label',
        descriptionKey: 'operations.reconciliation.run.matches.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.matches.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_CANCEL]: {
        id: OID.RECONCILIATION_RUN_CANCEL,
        name: 'Cancel Reconciliation Run',
        labelKey: 'action.cancel',
        descriptionKey: 'operations.reconciliation.run.cancel.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.cancel',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_RUN_RETRY]: {
        id: OID.RECONCILIATION_RUN_RETRY,
        name: 'Retry Reconciliation Run',
        labelKey: 'action.retry',
        descriptionKey: 'operations.reconciliation.run.retry.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.run.retry',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_BREAK_GET]: {
        id: OID.RECONCILIATION_BREAK_GET,
        name: 'Get Reconciliation Break',
        labelKey: 'operations.reconciliation.break.get.label',
        descriptionKey: 'operations.reconciliation.break.get.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.break.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_BREAK_UPDATE]: {
        id: OID.RECONCILIATION_BREAK_UPDATE,
        name: 'Update Reconciliation Break',
        labelKey: 'operations.reconciliation.break.update.label',
        descriptionKey: 'operations.reconciliation.break.update.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.break.update',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ADJUSTMENT_CREATE]: {
        id: OID.RECONCILIATION_ADJUSTMENT_CREATE,
        name: 'Create Reconciliation Adjustment',
        labelKey: 'operations.reconciliation.adjustment.create.label',
        descriptionKey: 'operations.reconciliation.adjustment.create.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.adjustment.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ADJUSTMENT_LIST]: {
        id: OID.RECONCILIATION_ADJUSTMENT_LIST,
        name: 'List Reconciliation Adjustments',
        labelKey: 'operations.reconciliation.adjustment.list.label',
        descriptionKey: 'operations.reconciliation.adjustment.list.description',
        permission: 'reconciliation:view',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.adjustment.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ADJUSTMENT_APPROVE]: {
        id: OID.RECONCILIATION_ADJUSTMENT_APPROVE,
        name: 'Approve Reconciliation Adjustment',
        labelKey: 'operations.reconciliation.adjustment.approve.label',
        descriptionKey: 'operations.reconciliation.adjustment.approve.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.reconciliation.adjustment.approve.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.adjustment.approve',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ADJUSTMENT_REJECT]: {
        id: OID.RECONCILIATION_ADJUSTMENT_REJECT,
        name: 'Reject Reconciliation Adjustment',
        labelKey: 'operations.reconciliation.adjustment.reject.label',
        descriptionKey: 'operations.reconciliation.adjustment.reject.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.reconciliation.adjustment.reject.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.adjustment.reject',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ADJUSTMENT_POST]: {
        id: OID.RECONCILIATION_ADJUSTMENT_POST,
        name: 'Post Reconciliation Adjustment',
        labelKey: 'operations.reconciliation.adjustment.post.label',
        descriptionKey: 'operations.reconciliation.adjustment.post.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.reconciliation.adjustment.post.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.adjustment.post',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_AGING_EXECUTE]: {
        id: OID.RECONCILIATION_AGING_EXECUTE,
        name: 'Execute Reconciliation Aging',
        labelKey: 'operations.reconciliation.aging.execute.label',
        descriptionKey: 'operations.reconciliation.aging.execute.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.aging.execute',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.RECONCILIATION_ESCALATION_EXECUTE]: {
        id: OID.RECONCILIATION_ESCALATION_EXECUTE,
        name: 'Execute Reconciliation Escalation',
        labelKey: 'operations.reconciliation.escalation.execute.label',
        descriptionKey: 'operations.reconciliation.escalation.execute.description',
        permission: 'reconciliation:create',
        module: 'RECONCILIATION',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'reconciliation.escalation.execute',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Corporate action operations ───
    [OID.CORPORATE_ACTION_LIST]: {
        id: OID.CORPORATE_ACTION_LIST,
        name: 'List Corporate Actions',
        labelKey: 'operations.corporateAction.list.label',
        descriptionKey: 'operations.corporateAction.list.description',
        permission: 'corporateAction:view',
        module: 'CORPORATE_ACTIONS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'corporateAction.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.CORPORATE_ACTION_CREATE]: {
        id: OID.CORPORATE_ACTION_CREATE,
        name: 'Create Corporate Action',
        labelKey: 'operations.corporateAction.create.label',
        descriptionKey: 'operations.corporateAction.create.description',
        permission: 'corporateAction:create',
        module: 'CORPORATE_ACTIONS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.corporateAction.create.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'corporateAction.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: true,
        supportDelegationEligible: false,
    },
    [OID.CORPORATE_ACTION_UPDATE]: {
        id: OID.CORPORATE_ACTION_UPDATE,
        name: 'Update Corporate Action',
        labelKey: 'operations.corporateAction.update.label',
        descriptionKey: 'operations.corporateAction.update.description',
        permission: 'corporateAction:update',
        module: 'CORPORATE_ACTIONS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.corporateAction.update.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'corporateAction.update',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PUT', 'PATCH'],
        isReadOnly: false,
        isFinancial: true,
        supportDelegationEligible: false,
    },
    // ─── Fact operations ───
    [OID.FACT_LIST]: {
        id: OID.FACT_LIST,
        name: 'List Facts',
        labelKey: 'operations.fact.list.label',
        descriptionKey: 'operations.fact.list.description',
        permission: 'fact:view',
        module: 'FACTS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'fact.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.FACT_GET]: {
        id: OID.FACT_GET,
        name: 'Get Fact',
        labelKey: 'operations.fact.get.label',
        descriptionKey: 'operations.fact.get.description',
        permission: 'fact:view',
        module: 'FACTS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'fact.get',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.FACT_CREATE]: {
        id: OID.FACT_CREATE,
        name: 'Create Fact',
        labelKey: 'operations.fact.create.label',
        descriptionKey: 'operations.fact.create.description',
        permission: 'fact:create',
        module: 'FACTS',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'fact.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    // ─── Navigation operations ───
    [OID.NAVIGATION_READ]: {
        id: OID.NAVIGATION_READ,
        name: 'Read Navigation',
        labelKey: 'operations.navigation.read.label',
        descriptionKey: 'operations.navigation.read.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.read',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.NAVIGATION_HUB]: {
        id: OID.NAVIGATION_HUB,
        name: 'Resolve Navigation Hub',
        labelKey: 'operations.navigation.hub.label',
        descriptionKey: 'operations.navigation.hub.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.hub',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    // NAV-005: Unique operation IDs for each navigation endpoint
    [OID.NAVIGATION_SHELL_READ]: {
        id: OID.NAVIGATION_SHELL_READ,
        name: 'Read Navigation Shell',
        labelKey: 'operations.navigation.shell.read.label',
        descriptionKey: 'operations.navigation.shell.read.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.shell.read',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.NAVIGATION_ROUTES_READ]: {
        id: OID.NAVIGATION_ROUTES_READ,
        name: 'Read All Route Decisions',
        labelKey: 'operations.navigation.routes.read.label',
        descriptionKey: 'operations.navigation.routes.read.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.routes.read',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.NAVIGATION_ROUTE_READ]: {
        id: OID.NAVIGATION_ROUTE_READ,
        name: 'Read Single Route Decision',
        labelKey: 'operations.navigation.route.read.label',
        descriptionKey: 'operations.navigation.route.read.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.route.read',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    [OID.NAVIGATION_HUB_READ]: {
        id: OID.NAVIGATION_HUB_READ,
        name: 'Read Navigation Hub',
        labelKey: 'operations.navigation.hub.read.label',
        descriptionKey: 'operations.navigation.hub.read.description',
        permission: 'navigation:read',
        module: 'NAVIGATION',
        requiresEntitledModule: false,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.SYSTEM,
            ScopeType.PLATFORM,
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
        ],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'navigation.hub.read',
        allowedActorTypes: [ActorType.USER, ActorType.CLIENT, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: true,
        delegationPolicy: 'READ_ONLY',
        accessType: 'READ',
    },
    // ─── Access operations ───
    [OID.ACCESS_READ_MEMBERS]: {
        id: OID.ACCESS_READ_MEMBERS,
        name: 'Read Members',
        labelKey: 'operations.access.members.read.label',
        descriptionKey: 'operations.access.members.read.description',
        permission: 'access:members:read',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.members.read',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ACCESS_READ_ROLES]: {
        id: OID.ACCESS_READ_ROLES,
        name: 'Read Roles',
        labelKey: 'operations.access.roles.read.label',
        descriptionKey: 'operations.access.roles.read.description',
        permission: 'access:roles:read',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.roles.read',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ACCESS_READ_PERMISSIONS]: {
        id: OID.ACCESS_READ_PERMISSIONS,
        name: 'Read Permissions',
        labelKey: 'operations.access.permissions.read.label',
        descriptionKey: 'operations.access.permissions.read.description',
        permission: 'access:permissions:read',
        module: 'ADMIN',
        ownershipPolicy: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        allowedScopeKinds: ['SYSTEM', 'PLATFORM'],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.permissions.read',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ACCESS_MANAGE_MEMBERSHIP]: {
        id: OID.ACCESS_MANAGE_MEMBERSHIP,
        name: 'Manage Memberships',
        labelKey: 'operations.access.membership.manage.label',
        descriptionKey: 'operations.access.membership.manage.description',
        permission: 'access:membership:manage',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.access.membership.manage.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.membership.manage',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST', 'PATCH', 'DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ACCESS_MANAGE_ROLES]: {
        id: OID.ACCESS_MANAGE_ROLES,
        name: 'Manage Roles',
        labelKey: 'operations.access.roles.manage.label',
        descriptionKey: 'operations.access.roles.manage.description',
        permission: 'access:roles:manage',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.access.roles.manage.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.roles.manage',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST', 'PATCH', 'DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ACCESS_MANAGE_PERMISSIONS]: {
        id: OID.ACCESS_MANAGE_PERMISSIONS,
        name: 'Manage Permissions',
        labelKey: 'operations.access.permissions.manage.label',
        descriptionKey: 'operations.access.permissions.manage.description',
        permission: 'access:permissions:manage',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.access.permissions.manage.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'access.permissions.manage',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST', 'PATCH', 'DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_AUDIT_LOG_LIST]: {
        id: OID.ADMIN_AUDIT_LOG_LIST,
        name: 'List Audit Logs',
        labelKey: 'operations.admin.auditLog.list.label',
        descriptionKey: 'operations.admin.auditLog.list.description',
        permission: 'admin:auditLog:view',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.auditLog.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_MODULES_LIST]: {
        id: OID.ADMIN_MODULES_LIST,
        name: 'List Modules',
        labelKey: 'operations.admin.modules.list.label',
        descriptionKey: 'operations.admin.modules.list.description',
        permission: 'admin:modules:view',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.modules.list',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_USER_CREATE]: {
        id: OID.ADMIN_USER_CREATE,
        name: 'Create User',
        labelKey: 'operations.admin.user.create.label',
        descriptionKey: 'operations.admin.user.create.description',
        permission: 'admin:user:create',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.user.create.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.ADVISORY_LOCK,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.user.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_USER_UPDATE]: {
        id: OID.ADMIN_USER_UPDATE,
        name: 'Update User',
        labelKey: 'operations.admin.user.update.label',
        descriptionKey: 'operations.admin.user.update.description',
        permission: 'admin:user:update',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.user.update.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.user.update',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_USER_DELETE]: {
        id: OID.ADMIN_USER_DELETE,
        name: 'Delete User',
        labelKey: 'operations.admin.user.delete.label',
        descriptionKey: 'operations.admin.user.delete.description',
        permission: 'admin:user:delete',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.user.delete.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.user.delete',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ROLE_CREATE]: {
        id: OID.ADMIN_ROLE_CREATE,
        name: 'Create Role',
        labelKey: 'operations.admin.role.create.label',
        descriptionKey: 'operations.admin.role.create.description',
        permission: 'admin:role:create',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.role.create.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.ADVISORY_LOCK,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.role.create',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['POST'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ROLE_UPDATE]: {
        id: OID.ADMIN_ROLE_UPDATE,
        name: 'Update Role',
        labelKey: 'operations.admin.role.update.label',
        descriptionKey: 'operations.admin.role.update.description',
        permission: 'admin:role:update',
        module: 'ADMIN',
        allowedPersonas: ['PLATFORM_ROOT', 'PLATFORM_ADMIN'],
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.SYSTEM, ScopeType.PLATFORM],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.role.update.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.role.update',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['PATCH'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.ADMIN_ROLE_DELETE]: {
        id: OID.ADMIN_ROLE_DELETE,
        name: 'Delete Role',
        labelKey: 'operations.admin.role.delete.label',
        descriptionKey: 'operations.admin.role.delete.description',
        permission: 'admin:role:delete',
        module: 'ADMIN',
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.PLATFORM, ScopeType.ORGANIZATION, ScopeType.BRANCH],
        requestedScope: {
            organizationId: [
                { source: 'path', field: 'organizationId' },
                { source: 'query', field: 'organizationId' },
            ],
            branchId: [
                { source: 'path', field: 'branchId' },
                { source: 'query', field: 'branchId' },
            ],
        },
        forcesClientScope: false,
        makerCheckerRequired: true,
        makerCheckerReasonKey: 'operations.admin.role.delete.makerChecker.reason',
        idempotencyPolicy: IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: ConcurrencyPolicy.OPTIMISTIC_VERSION,
        auditPolicy: AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'admin.role.delete',
        allowedActorTypes: [ActorType.USER],
        httpMethods: ['DELETE'],
        isReadOnly: false,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_METRICS_READ]: {
        id: OID.PLATFORM_METRICS_READ,
        name: 'Read Prometheus Metrics',
        labelKey: 'operations.metrics.read.label',
        descriptionKey: 'operations.metrics.read.description',
        permission: 'platform:health:read',
        permissionId: 'platform:health:read',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM],
        requestedScope: {},
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.metrics.read',
        allowedActorTypes: [ActorType.SYSTEM, ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
    [OID.PLATFORM_METRICS_READ_JSON]: {
        id: OID.PLATFORM_METRICS_READ_JSON,
        name: 'Read Metrics JSON',
        labelKey: 'operations.metrics.read-json.label',
        descriptionKey: 'operations.metrics.read-json.description',
        permission: 'platform:health:read',
        permissionId: 'platform:health:read',
        module: 'PLATFORM',
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.PLATFORM],
        requestedScope: {},
        forcesClientScope: false,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.INTERNAL,
        telemetryId: 'platform.metrics.read-json',
        allowedActorTypes: [ActorType.SYSTEM, ActorType.USER],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: false,
        supportDelegationEligible: false,
    },
};
